<template>
  <v-card>
    <v-overlay
      absolute
      opacity="0.8"
      :value="!hasData"
    >
      Facebook not linked
    </v-overlay>
    <v-card-title>
      <span>Audience age</span>
    </v-card-title>
    <v-card-subtitle>
      The age distribution of the IG User’s followers.
    </v-card-subtitle>
    <!-- Chart -->
    <vue-apex-charts
      height="320px"
      :options="chartOptions"
      :series="chartData"
    ></vue-apex-charts>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
// eslint-disable-next-line object-curly-newline
import { mdiDotsVertical } from '@mdi/js';

// import { getVuetify } from '@core/utils';

export default {
  components: {
    VueApexCharts,
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    // const $vuetify = getVuetify();
    const audienceGenderAgeData = props?.data;
    const chartOptions = {
      chart: {
        type: 'radar',
        toolbar: {
          show: false,
        },
      },

      // colors: [$vuetify.theme.currentTheme.primary, $vuetify.theme.currentTheme.info],
      labels: audienceGenderAgeData?.data?.charts?.label || ['no data'],
      markers: {
        size: 0,
      },
      xaxis: {
        labels: {
          style: {
            fontSize: '14px',
          },
        },
      },
      yaxis: {
        show: false,
      },
      grid: {
        show: false,
      },
    };

    const chartData = [
      {
        name: 'Female',
        data: audienceGenderAgeData?.data?.computed?.females?.chart?.values || [10],
      },
      {
        name: 'Male',
        data: audienceGenderAgeData?.data?.computed?.males?.chart?.values || [10],
      },
    ];

    return {
      chartOptions,
      chartData,
      hasData: audienceGenderAgeData,
      icons: {
        mdiDotsVertical,
      },
    };
  },
};
</script>
